var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "popularity" } }, [
    _c(
      "div",
      { staticClass: "side-menubar-wrapper" },
      [
        _c("SideMenuBar", {
          attrs: {
            "selected-page": "reports",
            "selected-sub-page": "popularity",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "chart-container" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c("FilterTool", {
              attrs: {
                isGraphShowing: true,
                "keep-state-on-query-params": true,
              },
              model: {
                value: _vm.filters,
                callback: function ($$v) {
                  _vm.filters = $$v
                },
                expression: "filters",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.loading
          ? _c(
              "div",
              {
                staticClass:
                  "h-50 d-flex flex-column justify-content-center align-items-center text-align-center",
              },
              [
                _c("a-spin"),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))]),
              ],
              1
            )
          : _c("div", { staticClass: "charts-wrapper" }, [
              _c("div", { staticClass: "sub-header" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    staticClass: "left",
                    attrs: {
                      content:
                        "This report shows the popularity of all interactions in a given your chatbot story",
                    },
                  },
                  [
                    _c("md-icon", [_vm._v("help")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("message.interactionPopularity"))),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _c(
                    "div",
                    {
                      staticClass: "export-button",
                      on: { click: _vm.exportToCsv },
                    },
                    [
                      _c("md-icon", [_vm._v("system_update_alt")]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.exportToCsv"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "export-button",
                      on: { click: _vm.exportToExcel },
                    },
                    [
                      _c("md-icon", [_vm._v("system_update_alt")]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.exportToExcel"))),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.dataSource && _vm.dataSource.length
                ? _c(
                    "div",
                    { staticClass: "charts-container" },
                    [
                      _c("a-table", {
                        staticClass: "blocks",
                        attrs: {
                          columns: _vm.columns,
                          dataSource: _vm.dataSource,
                          pagination: false,
                          rowClassName: _vm.getRowClassName,
                          rowKey: "_id",
                          size: "small",
                        },
                        on: { change: _vm.tableChange },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "name",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "blockName",
                                      attrs: {
                                        href: _vm.getBlockURL(record.id),
                                      },
                                      on: {
                                        click: function (e) {
                                          return _vm.gotoBlock(e, record.id)
                                        },
                                      },
                                    },
                                    [
                                      record.name
                                        ? _c("div", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(record.name) +
                                                "\n                                "
                                            ),
                                          ])
                                        : _c("div", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "chatbotv2." + record.type
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1804121771
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
        _vm._v(" "),
        !_vm.loading && _vm.dataSource && !_vm.dataSource.length
          ? _c(
              "div",
              { staticClass: "d-flex justify-content-center mt-5" },
              [
                _c("ChartNotFound", {
                  attrs: { title: _vm.$t("message.dataNotFound") },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }